module.exports = __webpack_public_path__ + "static/media/dai.36c42b6e.svg";